import React from "react";
import { Navigate } from "react-router-dom";
import { getPermissions, getToken } from "@/lib/auth";

type Props = {
  perm: string;
  children: React.ReactNode;
};

export function RequirePerm({ perm, children }: Props) {
  const token = getToken();

  // not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const permissions = getPermissions();

  // no permission
  if (!permissions.includes(perm)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
}